export const ICONS = {
  USERS_SOLID: 'users-solid',
  USER_PLUS_SOLID: 'user-plus-solid',
  FILE_SOLID: 'file-solid',
  BOOK_SOLID: 'book-solid',
  FILE: 'file',
  FILE_ALT: 'file-alt',
  FOLDER_PLUS_SOLID: 'folder-plus-solid',
  PLUS_CIRCLE_SOLID: 'plus-circle-solid',
  KEY_SOLID: 'key-solid'
};